import React from 'react';
import { Default, Mobile } from '../responsive';
import {
  getDates,
  getDatesMobile,
  prepareCurrentPorts,
  updateItemWithCurrentPort
} from '../utilsVisits';
import ClosingTimes from './closingTimes';
import Icons, { IconNames } from './icons';
import List from './list';

export default class VisitList extends React.Component {
  constructor(props) {
    super(props);
    this.visitsDTO = [];
  }

  componentWillMount() {
    if (!this.props.simpleView) {
      this.visitsDTO = prepareCurrentPorts(this.props.visits, this.props.ports);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.visits !== nextProps.visits) {
      return true;
    } else {
      return false;
    }
  }

  renderIcon(item) {
    const arrived = item.ATADate;
    const departed = item.ATDDate;
    updateItemWithCurrentPort(item, arrived, departed);
    if (item.current) {
      return (
        <Icons
          iconName={IconNames.SortRight}
          iconClassName="arrowRight"
          className="arrowRightWrapper"
        />
      );
    }
  }

  findNextVoyageDeparturePort(nextVoyage) {
    const visits = nextVoyage.visits;

    let lastVisitBeforeVoyage = visits[0];

    for (let i = 0; i < visits.length; i++) {
      if (
        lastVisitBeforeVoyage.Pool.Port.PortCode === visits[i].Pool.Port.PortCode &&
        visits[i].PortActivity !== 'D' &&
        lastVisitBeforeVoyage.VisitNumber !== visits[i].VisitNumber
      ) {
        lastVisitBeforeVoyage = visits[i];
        break;
      }
    }

    return lastVisitBeforeVoyage;
  }

  mapItems(visitsDTO) {
    if (!visitsDTO) {
      return [];
    }
    const headers = {
      Port: this.props.lang === 'is' ? 'Höfn' : 'Port',
      OriginalETADate: this.props.lang === 'is' ? 'Áætluð koma' : 'Scheduled Arrival',
      OriginalETDDate: this.props.lang === 'is' ? 'Áætluð brottför' : 'Scheduled Departure',
      Separator: '',
      ArrivalDate: this.props.lang === 'is' ? 'Koma' : 'Arrival',
      DepartureDate: this.props.lang === 'is' ? 'Brottför' : 'Departure'
      // ETADate: 'Estimated Arrival Date/Time',
      // ETDDate: 'Estimated Departure Date/Time',
      // ATADate: 'Actual Arrival Date/Time',
      // ATDDate: 'Actual Departure Date/Time',
    };

    let nextVoyage = null;

    if (this.props.nextVoyage) {
      nextVoyage = this.props.nextVoyage;
    }

    const visits = visitsDTO.map((item, index, array) => {
      const ArrivalDate = item.ATADate ? item.ATADate : item.ETADate;
      let DepartureDate = item.ATDDate ? item.ATDDate : item.ETDDate;

      const ADprefix = item.ATADate ? 'ATA' : 'ETA';
      let DDprefix = item.ATDDate ? 'ATD' : 'ETD';

      if (item.Port === 'In transit') {
        return item;
      }

      const lastPort = index === array.length - 1;

      if (lastPort && nextVoyage !== null && nextVoyage !== undefined) {
        const nextVoyageDeparturePort = this.findNextVoyageDeparturePort(nextVoyage);

        item.OriginalETDDate = nextVoyageDeparturePort.OriginalETDDate;
        DepartureDate = nextVoyageDeparturePort.ATDDate
          ? nextVoyageDeparturePort.ATDDate
          : nextVoyageDeparturePort.ETDDate;
      }

      return {
        Port: item.Pool.Port.LocalName,
        ArrivalDate: getDates(ArrivalDate, item.Pool.Port.TimeZoneDiff, ADprefix),
        DepartureDate: getDates(DepartureDate, item.Pool.Port.TimeZoneDiff, DDprefix),
        ETADate: getDates(item.ETADate, item.Pool.Port.TimeZoneDiff),
        ETDDate: getDates(item.ETDDate, item.Pool.Port.TimeZoneDiff),
        ATADate: getDates(item.ATADate, item.Pool.Port.TimeZoneDiff),
        ATDDate: getDates(item.ATDDate, item.Pool.Port.TimeZoneDiff),
        OriginalETADate: getDates(item.OriginalETADate, item.Pool.Port.TimeZoneDiff),
        OriginalETDDate: getDates(item.OriginalETDDate, item.Pool.Port.TimeZoneDiff),
        current: item.current,
        visited: item.visited,
        Separator: '',
        lastPort: lastPort.toString(),
        PortActivity: item.PortActivity
      };
    });

    return { visits, headers };
  }

  mapItemsMobile(visitsDTO) {
    if (!visitsDTO) {
      return [];
    }
    const headers = {
      Port: 'Port',
      Icon: ''
    };

    const visits = visitsDTO.map((item, index, array) => {
      const ArrivalDate = item.ATADate ? item.ATADate : item.ETADate;
      const DepartureDate = item.ATDDate ? item.ATDDate : item.ETDDate;

      const ADprefix = item.ATADate ? 'ATA' : 'ETA';
      const DDprefix = item.ATDDate ? 'ATD' : 'ETD';

      if (item.Port === 'In transit') {
        return item;
      }

      return {
        Port: item.Pool.Port.LocalName,
        ArrivalDate: getDatesMobile(ArrivalDate, item.Pool.Port.TimeZoneDiff, ADprefix),
        DepartureDate: getDatesMobile(DepartureDate, item.Pool.Port.TimeZoneDiff, DDprefix),
        ETADate: getDatesMobile(item.ETADate, item.Pool.Port.TimeZoneDiff),
        ETDDate: getDatesMobile(item.ETDDate, item.Pool.Port.TimeZoneDiff),
        ATADate: getDatesMobile(item.ATADate, item.Pool.Port.TimeZoneDiff),
        ATDDate: getDatesMobile(item.ATDDate, item.Pool.Port.TimeZoneDiff),
        OriginalETADate: getDatesMobile(item.OriginalETADate, item.Pool.Port.TimeZoneDiff),
        OriginalETDDate: getDatesMobile(item.OriginalETDDate, item.Pool.Port.TimeZoneDiff),
        current: item.current,
        visited: item.visited,
        Separator: '',
        Icon: (
          <Icons
            iconName={IconNames.ArrowRight}
            iconClassName="portLink"
            className="portLinkWrapper"
          />
        )
      };
    });

    return { visits, headers };
  }

  getClassNames(item) {
    let classNames = [];
    classNames.push('list__items__item');

    if (item.visited) {
      classNames.push('port__visited');
    }
    if (item.current) {
      classNames.push('current__port');
    }
    if (item.inTransit) {
      classNames.push('inTransit');
    }
    return classNames;
  }

  render() {
    const { visits, headers } = this.mapItems(this.visitsDTO);
    const contentMobile = this.mapItemsMobile(this.visitsDTO);

    if (this.props.simpleView) {
      return null;
    }

    return (
      <React.Fragment>
        <Default>
          <List
            headers={headers}
            items={visits}
            portRegistry={this.props.portRegistry}
            hideHeaders={this.props.hideHeaders}
            onClickItem={this.props.onClickItem}
          />
        </Default>
        <Mobile>
          <List
            headers={contentMobile.headers}
            items={contentMobile.visits}
            portRegistry={this.props.portRegistry}
            hideHeaders={this.props.hideHeaders}
            onClickItem={this.props.onClickItem}
          />
        </Mobile>
        {this.props.showClosingTimes && (
          <ClosingTimes title="Closing time for cargo" displayLinkOnly />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/visitlist.js